import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { isMobile } from "react-device-detect";
import { BankIdData, BidHintCode } from "../types/bankId";
import { REACT_APP_NAME } from "../env";
import { Button } from "../../../components/src/Button";

interface BankIdLoginProps {
    bankIdData: BankIdData;
    onRestart: () => void;
    onToggleMode: () => void;
    onOpenBankIdApp: () => void;
}

export const BankIdLogin: React.FC<BankIdLoginProps> = ({ bankIdData, onRestart, onToggleMode, onOpenBankIdApp }) => {
    return (
        <div
            className="fixed inset-0 flex justify-center items-center bg-cover bg-center bg-no-repeat px-4"
            style={{
                backgroundImage: "url(/background_europe.jpg)",
                fontFamily: "Inter"
            }}
        >
            <div className="flex flex-wrap -mx-2 w-full max-w-[380px]">
                <div className="w-full" style={{ background: "white", borderRadius: "5px" }}>
                    <h2
                        className="text-center py-2"
                        style={{
                            justifyContent: "center",
                            alignItems: "center",
                            borderTopLeftRadius: "5px",
                            borderTopRightRadius: "5px",
                            background: "#0284c7",
                            color: "white"
                        }}
                    >
                        {REACT_APP_NAME.toUpperCase()}
                    </h2>
                    <h2 className="flex mr-4 ml-4 justify-center">
                        <span>Login with BankID</span>
                    </h2>
                    <div className="flex flex-wrap -mx-2 px-4">
                        <div className="flex-1 px-2">
                            {bankIdData.qrCode ? (
                                <div className="flex justify-center">
                                    {isMobile ? (
                                        <Button className="mt-4" variant="primary" onClick={onOpenBankIdApp}>
                                            Open BankId on same device
                                        </Button>
                                    ) : (
                                        <>
                                            {bankIdData.hintCode === BidHintCode.outstandingTransaction ? (
                                                <QRCodeCanvas value={bankIdData.qrCode} />
                                            ) : (
                                                <div>
                                                    {bankIdData.hintCode === BidHintCode.userSign
                                                        ? "Sign in with your BankID app"
                                                        : bankIdData.hintCode}
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            ) : (
                                <div className="flex mt-4 justify-center">
                                    <Button className="w-full mt-4" variant="secondary" onClick={onRestart}>
                                        Restart BankID login
                                    </Button>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="mt-4 mb-4 text-center" style={{ justifyContent: "center", alignItems: "center" }}>
                        {bankIdData.hintCode === BidHintCode.startFailed && bankIdData.qrCode ? (
                            <Button className="w-full mt-4" variant="secondary" onClick={onRestart}>
                                Restart BankID login
                            </Button>
                        ) : (
                            <button
                                className="text-sky-600 hover:text-sky-800 underline bg-transparent border-none cursor-pointer"
                                type="button"
                                onClick={onToggleMode}
                            >
                                Login with password instead
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
